import { Component, inject } from '@angular/core';
import { Router } from '@angular/router';
import {
  GcIconComponent,
  GcModalComponent,
  GcTextComponent,
  IpoTranslatePipe,
} from '@ip-only/front-end-library';
import { FeedbackAlertComponent } from '../../feedback-alert/feedback-alert.component';
import {
  DOWNLOAD_COPY_PRESSED,
  RETURN_REPORT_PRESSED,
} from '../../posthug-analytics/analytics-event-types';
import { AnalyticsService } from '../../posthug-analytics/analytics.service';
import { SignatureDataService } from '../../signature/service/signature-data/signature-data.service';

@Component({
  selector: 'app-signing-confirmation-modal',
  standalone: true,
  imports: [
    GcModalComponent,
    IpoTranslatePipe,
    GcTextComponent,
    GcIconComponent,
    FeedbackAlertComponent,
  ],
  templateUrl: './signing-confirmation-modal.component.html',
  styleUrl: './signing-confirmation-modal.component.scss',
})
export class SigningConfirmationModalComponent {
  private readonly router = inject(Router);
  private readonly signatureDataService = inject(SignatureDataService);
  private readonly analyticsService = inject(AnalyticsService);

  downloadPdfLoadingState = this.signatureDataService.downloadPdfLoadingState;

  handleReturnToReport() {
    this.signatureDataService.setConfirmModalState(false);
    const url: string = this.router.url;
    const newUrl = url.substring(0, url.lastIndexOf('/'));
    window.location.href = newUrl;

    this.analyticsService.logEvent(RETURN_REPORT_PRESSED);
  }

  handleDownloadReport() {
    this.signatureDataService.downloadStoredPdf();
    this.analyticsService.logEvent(DOWNLOAD_COPY_PRESSED);
  }
}
